import { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size?: number
}

export const SubscribeCardIconMessage = ({ size = 24, ...props }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4.5C16.1425 4.5 19.5 7.85912 19.5 12C19.5 13.6113 18.9937 15.1014 18.1301 16.3228C17.7711 16.8305 17.6992 17.5376 18.0679 18.1034L18.8009 19.2282C18.842 19.2914 18.8815 19.3703 18.9108 19.4516C18.9169 19.4684 18.9222 19.4845 18.9269 19.5H12C7.8574 19.5 4.5 16.1426 4.5 12C4.5 7.85912 7.85747 4.5 12 4.5ZM18.9552 19.6714C18.9551 19.6714 18.9552 19.6701 18.9557 19.6678C18.9555 19.6703 18.9552 19.6715 18.9552 19.6714Z"
        stroke="white"
        strokeOpacity="0.7"
      />
      <path
        d="M13.6025 7.8765C13.6784 7.73779 13.8776 7.73779 13.9535 7.8765L14.6927 9.22813C14.711 9.26169 14.7386 9.28928 14.7722 9.30763L16.1238 10.0469C16.2625 10.1227 16.2625 10.3219 16.1238 10.3978L14.7722 11.137C14.7386 11.1554 14.711 11.183 14.6927 11.2165L13.9535 12.5682C13.8776 12.7069 13.6784 12.7069 13.6025 12.5682L12.8633 11.2165C12.8449 11.183 12.8173 11.1554 12.7838 11.137L11.4322 10.3978C11.2935 10.3219 11.2935 10.1227 11.4322 10.0469L12.7838 9.30763C12.8173 9.28928 12.8449 9.26169 12.8633 9.22813L13.6025 7.8765Z"
        fill="#D9D9D9"
      />
    </svg>
  )
}
